<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="tableOptions"
    :server-items-length="count"
    :items-per-page="5"
    :headers="headers"
    :items="items"
    @input="$emit('update:selected', $event)"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    disable-sort
  >
    <template v-slot:[`item.title`]="{ item }">
      <div class="d-flex align-center py-2">
        <img v-if="item.thumbnail" :src="item.thumbnail" style="height: 60px;" />
        <div
          v-else
          style="height: 60px; width: 60px; background-color: lightgrey;"
          class="d-flex align-center justify-center"
          title="Chưa có ảnh đại diện"
        >
          <v-icon color="white">mdi-image-area</v-icon>
        </div>
        <router-link :to="'/events/' + item.id" class="ml-2">
          <div>{{ item.title }}</div>
        </router-link>
      </div>
    </template>
    <template v-slot:[`item.fromTo`]="{ item }">
      <div>{{ item.from | ddmmyyyy }} - {{ item.to | ddmmyyyy }}</div>
    </template>
    <template v-slot:[`item.isPublished`]="{ item }">
      <v-chip :color="item.isPublished | eventStatusColor" small class="white--text">
        {{ item.isPublished ? 'Xuất bản' : 'Chưa xuất bản' }}
      </v-chip>
    </template>
    <template v-slot:[`item.isOpenRegistration`]="{ item }">
      <v-chip :color="item.isOpenRegistration | eventStatusColor" small class="white--text">
        {{ item.isOpenRegistration ? 'Đang mở' : 'Đã đóng' }}
      </v-chip>
    </template>
    <template v-slot:[`item.isExpired`]="{ item }">
      <v-chip :color="item.isExpired | eventExpiredColor" small class="white--text">
        {{ item.isExpired ? 'Hết hạn' : 'Còn hạn' }}
      </v-chip>
    </template>
    <template v-slot:[`item.appliedType`]="{ item }">
      <div>{{ item.appliedType | getAppliedTypeText }}</div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon color="primary">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/events/' + item.id">
            <v-list-item-title style="cursor: pointer">Sửa</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import helpers from './helpers'

export default {
  data: () => ({ tableOptions: {}, headers: helpers.EVENT_TABLE_HEADERS }),
  methods: {
    ...mapActions({
      requestPageSettings: 'events/requestPageSettings'
    })
  },
  computed: {
    ...mapState('events', ['count', 'items', 'pageText', 'loading']),
    footerTable() {
      const footer = {
        'items-per-page-text': 'Số sự kiện mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  },
  filters: {
    getAppliedTypeText(appliedType) {
      return helpers.APPLIED_TYPE[appliedType]
    },
    eventStatusColor(val) {
      return val ? 'green' : 'grey'
    },
    eventExpiredColor(val) {
      return val ? 'red' : 'green'
    }
  }
}
</script>
